import { render, staticRenderFns } from "./class-attendance-check-list.vue?vue&type=template&id=bad4686e"
import script from "./class-attendance-check-list.vue?vue&type=script&lang=js"
export * from "./class-attendance-check-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports